module.exports = __webpack_public_path__ + "img/fwzt06_1.921cebf.png";